import { Loader2 } from "lucide-react";
import { Seo } from "../Seo";
import { AdminLogin } from "./AdminLogin";

// Shared gate for admin pages: spinner while the cookie session is checked, login form if none.
export const AdminGate = ({ page, authed, login, children }) => {
  if (authed === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="admin-session-loading">
        <Seo page={page} />
        <Loader2 className="w-6 h-6 animate-spin text-cyan-700" />
      </div>
    );
  }
  if (!authed) return <><Seo page={page} /><AdminLogin onLogin={login} /></>;
  return children;
};
